import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import EditModal from 'components/UI/EditModal';
import Button from 'components/UI/Button';
import { Content, ButtonGrid } from './styled';
import { FieldValues, SubmitHandler, useForm } from 'react-hook-form';
import { useAppDispatch } from 'hooks/redux';
import Heading, { Type as HeadingType } from 'components/UI/Heading';
import { startRollout } from 'store/rolloutState/rolloutState';
import { TableRollout } from '../RolloutTable';

type Props = {
  rollout: TableRollout | undefined;
  open: boolean;
  onClose: () => void;
};

const RolloutStartConfirmation: FC<Props> = ({ rollout, open, onClose }) => {
  const dispatch = useAppDispatch();
  const { handleSubmit } = useForm();

  // Submit
  const onSubmit: SubmitHandler<FieldValues> = useCallback(
    () => {
      if (rollout) {
        dispatch(startRollout(rollout.link));
        onClose();
      }
    },
    [dispatch, rollout, onClose]
  );

  return (
    <EditModal title="rollout.confirm_start_title" open={open} close={onClose}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Content>
          <Heading type={HeadingType.h4}>
            <FormattedMessage
              id="rollout.confirm_start_text"
              values={{
                numbDevices: rollout?.progress.notStarted,
                software: rollout?.software,
                rollout: rollout?.name,
              }}
            />
          </Heading>
        </Content>
        <ButtonGrid>
          <Button
            onClick={onClose}
            backgroundColor="transparent"
            color="primary"
          >
            <FormattedMessage id="rollout.btn_cancel" />
          </Button>
          <Button submit>
            <FormattedMessage id="rollout.btn_confirm" />
          </Button>
        </ButtonGrid>
      </form>
    </EditModal>
  );
};

export default RolloutStartConfirmation;
